import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
import UnitInfo from '@/components/units/pageInfo/info-block/UnitInfo.vue';

const unitHwTypeTransformation = consts.unitHwTypeTransformationToRoute
const unitTypeTransformation = consts.unitTypeTransformationToRoute

function getUnitDefaultRouteParams(unitId, template) {
    let unit = store.getters.getUnitsByIds[unitId]
    if(unit?.id) localStorage.setItem(store.getters.getUserStorageKey + '.unit.active', unitId);
    template = template
        || unitHwTypeTransformation?.[unit?.hw_type]?.type?.[unit?.type]
        || unitHwTypeTransformation?.[unit?.hw_type]?.template
        || unitTypeTransformation[unit?.type]
        || unit?.hw_type

    let routeName = consts.routerNames?.units?.type[template]

    //if(store.getters.isUnitsFullLoad){
        if (!routeName) {
            if (unit?.video) {
                template = 'xvision'
                routeName = consts.routerNames?.units?.type?.xvision
            } /*else
            if(unit?.reefer_type) {
                template = 'xcool'
                routeName = consts.routerNames?.units?.type?.xcool
            }*/
            else {
                template = 'xtrack'
                routeName = consts.routerNames?.units?.type?.xtrack
            }
        }
    //}
    if (!unitId) routeName = consts.routerNames.units

    return {
        routeName,
        params: {
            unitId,
            template
        }
    }
}

function clearQueryFilter(query) {
    delete query.hideEvents
    return query
}

const defaultSetRoute = {
    units: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('units', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units.main,
            params: {},
            query: {}
        })
    },
    returnToParent: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn(consts.routerNames.units.main + ' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.units.main;
        let query = clearQueryFilter(route.query)
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query
        })
    },
    unitsAll: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('units', route);
            return false;
        }
        let query = clearQueryFilter(route.query)
        router.push({
            name: consts.routerNames.units.all.main,
            params: {},
            query
        })
    },
    unitId: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        if (store.getters?.getUnitsOnMap?.length) {
            store.commit('setUnitsShowOnMap', {
                showOnMap: false,
                unitIds: store.getters?.getUnitsOnMap
            })
        }

        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        date = date || route?.params?.date || store.getters.getDateToday

        router.push({
            name: routeParams?.routeName?.date || consts?.routerNames?.units?.id,
            params: {
                ...routeParams?.params,
                date,
            },
            query
        })
    },
    changeDateFilter: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('changeDateFilter', route);
            return false;
        }

        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        date = date || route?.params?.date || store.getters.getDateToday

        router.push({
            name: route.name,
            params: {
                ...route.params,
                ...routeParams?.params,
                date,
            },
            query
        })
    },
    unitIdShifts: (route, router, unitId, date, timeFrom, timeTo, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        if (store.getters?.getUnitsOnMap?.length) {
            store.commit('setUnitsShowOnMap', {
                showOnMap: false,
                unitIds: store.getters?.getUnitsOnMap
            })
        }

        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        date = date || route?.params?.date || store.getters.getDateToday

        router.push({
            name: routeParams?.routeName?.date || consts?.routerNames?.units?.id,
            params: {
                ...routeParams?.params,
                date,
                timeFrom,
                timeTo,
            },
            query
        })
    },
    liteTemplate: (route, router, lite) => {
        console.warn('liteTemplate', route, router, lite)
        return false;
    },
    unitEdit: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitEdit', route);
            return false;
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: consts.routerNames.units.edit.main,
            params: {
                ...routeParams.params,
                unitId,
            },
            query: {...route.query}
        })

    },
    unitXRoute: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitXRoute', route);
            return false;
        }
        //let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: consts.routerNames.units.xroute.main,
            params: {
                ...route.params,
                unitId,
                date: store.getters.getDateToday
            },
            query: {...route.query}
        })

    },
    unitInfo: (route, router, unitId, date) => {
        console.warn('unitInfo', route, router, unitId, date)
        return false;
    },
    unitReefer: (route, router, unitId) => {
        console.warn('unitReefer', route, router, unitId)
        return false;
    },
    trackParams: (route, router, date, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.track.main) {
            if(consts.app.$isDevelopment) console.warn('trackParams', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        date = date || route?.params?.date || store.getters.getDateToday
        let unit = store.getters.getUnitsByIds[unitId]
        let name = consts.routerNames.units.track.main
        if(consts.typesForTrackByPoints.includes(unit?.type)) {
            name = consts.routerNames.units.track.asset.main
        }

        router.push({
            name,
            params: {
                ...routeParams.params,
                date
            },
            query: {...route.query}
        })
    },
    trackVideoEventPopup: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.track.main) {
            if(consts.app.$isDevelopment) console.warn('trackParams', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.track.video.event,
            params: {
                ...route.params,
                trackEventType,
                trackEventXid,
            },
        })
    },
    drivingAssetIndex: (route, router, index) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        router.push({
            name: consts.routerNames.tracks.unit.asset.index,
            params: {
                ...route.params,
                index: index,
            },
            query: {...route.query}
        })
    },
    unitReeferTemplate: (route, router, unitId, objectName) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitReeferTemplate', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams.routeName[objectName]?.main || routeParams.routeName[objectName],
            params: {
                ...routeParams.params,
            },
            query: {...route.query}
        })
    },
    unitReeferAlert: (route, router, unitId, xid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitReeferTemplate', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams.routeName.alarms.xid,
            params: {
                ...routeParams.params,
                alertXid: xid,
            },
            query: {...route.query}
        })
    },
    unitReeferGreenSee: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (this.$isDevelopment) console.warn('unitReeferGreenSee', route);
            return false
        }
        router.push({
            name: consts.routerNames.md.xcool.greenSee.main,
            params: {
                unitId
            },
            query: {...route.query}
        })
    },
    unitStationAnalytics: (route, router, unitId) => {
        console.warn('unitStationAnalytics', route, router, unitId)
        return false;
    },
    unitGenerator: (route, router, unitId, name) => {
        console.warn('unitGenerator', route, router, unitId, name)
        return false;
    },
    unitsFilter: (route, router, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitsFilter', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params
            },
            query: {...filter}
        })
    },
    liveVideo: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('liveVideo', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        template = template || routeParams?.template
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName?.liveVideo,
            params: {
                ...routeParams.params,
                template,
            },
            query
        })
    },
    unitSnapshots: (route, router, unitId, date, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams.routeName.snapshots,
            params: {
                ...routeParams.params,
                date,
                eventXid,
                objectType: 'screenshot',
            },
            query: {...route.query}
        })
    },
    visionMD: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams.routeName.visionMD.main,
            params: {
                ...routeParams.params,
            },
            query: {...route.query}
        })
    },
    mapEvent: (route, router, unitId, eventXid, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('event', route);
            return false
        }
        template = template || route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName.mapEvent,
            params: {
                ...routeParams.params,
                eventXid,
            },
            query
        })
    },
    event: (route, router, unitId, eventXid, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('event', route);
            return false
        }
        template = template || route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName.event,
            params: {
                ...routeParams.params,
                eventXid,
                date,
            },
            query
        })
    },
    'video-event': (route, router, unitId, eventXid, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-event', route);
            return false
        }
        template = template || route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        let isLatlng = store.getters.getVideoEvents.find(e => e.xid == eventXid)?.latlng
        router.push({
            name: routeParams.routeName[isLatlng ? 'videoEvent' : 'videoEventUnitTracking'],
            params: {
                ...routeParams.params,
                eventXid,
            },
            query
        })
    },
    'video-request': (route, router, unitId, eventXid, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-request', route);
            return false
        }
        template = template || route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        let isLatlng = store.getters.getVideoRequests.find(e => e.xid == eventXid)?.latlng
        router.push({
            name: routeParams.routeName[isLatlng ? 'videoRequest' : 'videoRequestUnitTracking'],
            params: {
                ...routeParams.params,
                template,
                eventXid,
            },
            query
        })
    },
    screenshotEvent: (route, router, unitId, eventXid, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('screenshots', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName.screenshotsEvent,
            params: {
                ...routeParams.params,
                eventXid,
                date,
            },
            query
        })
    },
    fastGeoitem: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('fastGeoitem', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.fastGeozone.main,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    fastGeoitemGroup: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('fastGeoitem', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.fastGeozone.group,
            params: {},
            query: {...route.query}
        })
    },
    track: (route, router, unitId, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('track', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        date = date || route?.params?.date || store.getters.getDateToday
        let unit = store.getters.getUnitsByIds[unitId];
        let name = consts.routerNames.units.track.main;
        if(consts.typesForTrackByPoints.includes(unit?.type)) {
            name = consts.routerNames.units.track.asset.main
        }
        router.push({
            name,
            params: {
                ...routeParams.params,
                date,
            },
            query: {
                ...route.query
            }
        })
    },
    trackXid: (route, router, type, trackXid, timeFrom, timeTo, trackColor) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        let unitId = route?.params?.unitId
        let routeParams = getUnitDefaultRouteParams(unitId)
        let date = route?.params?.date
        let query = {...route.query}
        delete query.hideEvents
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: consts.routerNames.units.track.xid,
            params: {
                ...routeParams.params,
                date,
                type,
                trackXid,
                timeFrom,
                timeTo,
                trackColor,
            },
            query: {...route.query}
        })
    },
    unitTrackXid: (route, router, date, type, trackXid, timeFrom, timeTo, trackColor, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        let unitId = route?.params?.unitId
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: consts.routerNames.units.track.xid,
            params: {
                ...routeParams.params,
                date,
                type,
                trackXid,
                timeFrom,
                timeTo,
                trackColor,
            },
            query: {
                ...route.query,
                ...filter,
            }
        })
    },
    trackColor: (route, router, trackColor) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: route.name,
            params: {
                ...route?.params,
                trackColor,
            },
            query: {...route.query}
        })
    },
    unitChangePrams: (route, router, params = {}, query = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitChangePrams', route);
            return false;
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
                ...params,
            },
            query: {...route.query, ...query}
        })
    },
    setQueryParams: (route, router, query) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('setQueryParams', route);
            return false;
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
            },
            query
        })
    },
    smartSearch: (route, router, type, filter = {}, query = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('smartSearch', route);
            return false;
        }
        let params = {
            ...route.params,
            ...filter,
        }

        if(type === 'geozone') {
            params.timeFrom = '';
            params.timeTo = '';
        }

        if(['time', 'geozone'].includes(type)) {
            params.mode = type
        }

        router.push({
            name: consts.routerNames.units.smartSearch[type].main,
            params,
            query: {
                ...query
            }
        })
    },
    smartSearchRequest: (route, router, type, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-request', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: consts.routerNames.units.smartSearch[type].videoRequest,
            params: {
                ...routeParams.params,
                eventXid,
            },
            query: {...route.query}
        })
    },
    smartSearchAccident: (route, router, type, accidentId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-request', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.smartSearch[type].accidentView,
            params: {
                ...route.params,
                accidentId,
            },
            query: {...route.query}
        })
    },
    timeCapsule: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('timeCapsule', route);
            return false;
        }
        date = date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
        }

        router.push({
            name: consts.routerNames.units.timeCapsule.template[template].main,
            params,
            query: {...route.query}
        })
    },
    timeCapsuleDate: (route, router, unitId, date, timeFrom, timeTo, template, queryFilter = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('timeCapsuleDate', route);
            return false;
        }
        date = date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
            timeFrom,
            timeTo,
        }

        router.push({
            name: consts.routerNames.units.timeCapsule.template[template].date,
            params,
            query: {...route.query, ...queryFilter}
        })
    },
    timeCapsuleVideo: (route, router, eventXid, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('timeCapsuleVideo', route);
            return false;
        }
        date = date || route.params?.date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
            eventXid,
        }

        router.push({
            name: consts.routerNames.units.timeCapsule.template.xvision.video,
            params,
            query: {...route.query}
        })
    },
    playback: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('playback', route);
            return false;
        }
        date = date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
        }

        router.push({
            name: consts.routerNames.units.playback.template[template].main,
            params,
            query: {...route.query}
        })
    },
    playbackDate: (route, router, unitId, date, timeFrom, timeTo, template, queryFilter = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('playbackDate', route);
            return false;
        }
        date = date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
            timeFrom,
            timeTo,
        }

        router.push({
            name: consts.routerNames.units.playback.template[template].date,
            params,
            query: {...route.query, ...queryFilter}
        })
    },
    playbackTime: (route, router, unitId, time, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('playbackTime', route);
            return false;
        }
        let params = {
            ...route.params,
            time,
        }

        router.push({
            name: consts.routerNames.units.playback.template[template].date,
            params,
            query: {...route.query}
        })
    },
    trackEvent: (route, router, trackEventType, trackEventXid, trackEventTime = null) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        let params = {...route.params, trackEventType, trackEventXid}
        if (params.unitId && params.date && !(params.type && params.trackXid) && trackEventTime) {
            if (consts.app.$isDevelopment) console.warn('trackEvent', route.params);
            const parkings = store.getters.getParkings
                .filter(p => p.unit_id == params.unitId && p.time_start.date == params.date)
            const trips = store.getters.getTrips
                .filter(t => t.unit_id == params.unitId && t.time_start.date == params.date)
            const item = [...trips, ...parkings]
                //.filter(i => i.unit_id == params.unitId && i.time_start.date == params.date)
                .find(i => i.time_start.utc <= trackEventTime && trackEventTime <= i.time_end.utc)
            if (!item) return false
            params = {
                ...params,
                type: item.type,
                trackXid: item.xid,
                timeFrom: item.time_start.utc,
                timeTo: item.time_end.utc,
                trackColor: 'track-color'
            }
        }
        router.push({
            name: consts.routerNames.units.track.event_xid,
            params,
            query: {...route.query}
        })
    },
    trackMoveOnTrack: (route, router, speed) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackColor', route);
            return false
        }
        let params = {...route?.params}
        if (speed) {
            params.speed = speed
        } else if (params.speed) {
            delete params.speed
        }
        router.push({
            name: route.name,
            params,
            query: {...route.query}
        })
    },
    unitsGroupEdit: (route, router, groupId) => {
        console.warn('unitsGroupEdit', route, router, groupId)
        return false;

    },
    unitCommand: (route, router, unitId) => {
        console.warn('unitCommand', route, router, unitId)
        return false;
    },
    unitsGroupCommand: (route, router, groupId) => {
        console.warn('unitsGroupCommand', route, router, groupId)
        return false;
    },
    unitsLocator: (route, router, unitId) => {
        console.warn('unitsLocator', route, router, unitId)
        return false;
    },
    unitChat: (route, router, unitId) => {
        console.warn('unitChat', route, router, unitId)
        return false;
    },
    sensors: (route, router, unitId) => {
        console.warn('sensors', route, router, unitId)
        return false;
    },
    notificationsId: (route, router, notificationType, notificationId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('notificationsId', route);
            return false
        }
        let unitId = route?.params?.unitId
        let routeParams = getUnitDefaultRouteParams(unitId)
        let date = route?.params?.date || store.getters.getDateToday
        router.push({
            name: consts.routerNames.units.info + '.notifications',
            params: {
                ...routeParams.params,
                date,
                notificationType,
                notificationId,
            },
            query: {...route.query}
        })
    },
    xblesUnitId: (route, router, unitId, tagId, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let query = clearQueryFilter(route.query)
        let name = tagId ? consts.routerNames?.units?.type?.xbles?.id?.main : consts.routerNames.units.type.xbles.date
        date = date || store.getters.getDateToday
        router.push({
            name,
            params: {
                unitId,
                template: 'xbles',
                tagId,
                date,
            },
            query
        })
    },
    obdMap: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('obdMap', route);
            return false;
        }

        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)

        router.push({
            name: routeParams?.routeName.map,
            params: {
                ...routeParams?.query,
            },
            query: {...route.query}
        })
    },
    switchTemplate: (route, router, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('switchTemplate', route);
            return false;
        }

        let unitId = route?.params?.unitId
        let date = route?.params?.date || store.getters.getDateToday
        router.push({
            name: consts.routerNames?.units?.type[template]?.date,
            params: {
                unitId,
                template,
                date,
            },
            query: {...route.query}
        })
    },
    map: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('Map', route);
            return false;
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams?.routeName.map,
            params: {
                ...routeParams?.query,
            },
            query: {...route.query}
        })
    },
    changeDate: (route, router, date, timeFrom, timeTo) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('Map', route);
            return false;
        }
        router.push({
            name: route.name,
            params: {
                date,
                timeFrom,
                timeTo,
            },
            query: {...route.query}
        })
    },
    unitsSharedLink: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('SharedLink', route);
            return false
        }
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        router.push({
            name: routeParams?.routeName.sharedLinks,
            params: {
                ...route.params,
                unitId,
            },
            query: {
                ...route.query
            }
        })
    },
    xRouteView: (route, router, unitId, routeId, calculateRouteId, waypointId, waypointType) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('xRouteView', route);
            return false
        }
        let routeName = calculateRouteId ? consts.routerNames?.units?.xroute.id.calculateRouteId : consts.routerNames?.units?.xroute.id.main
        router.push({
            name: routeName,
            params: {
                routeId,
                unitId,
                calculateRouteId,
                waypointId,
                waypointType,
                date: store.getters.getDateToday
            },
            query: {
                ...route.query,
            }
        })
    },
}

function replaceParams(route) {
    let unitId = route?.params?.unitId
    let unit = store.getters.getUnitsByIds[unitId]
    if(unitId && unit?.hw_type == 'xtag' && unit?.parent__id) {
        unitId = unit?.parent__id
    }
    return {...route?.params, unitId}
}
const routesUnits = (!['prometheus.portal', 'prometheus.portal.geotab'].includes(process.env.VUE_APP_PACKAGE)) ? [] : [
    {
        path: 'units/:pathMatch(.*)?',
        name: consts.routerNames.units.main,
        meta: {
            list: 'UnitsList',
            mainRouteName: consts.routerNames.units.main,
            pageLayout: 'block-position-unit',
            showMap: true,
            weatherInMap: true,
            unitTracking: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
            getUnitDefaultRouteParams: (unitId) => getUnitDefaultRouteParams(unitId)
        },
        props: {
            default: function (route) {
                let params = replaceParams(route)
                return {unitId: +params.unitId}
            },
        },
        components: {
            default: () => import('@/views/prometheus/portal/UnitsPage.vue'),
        },
        children: [
            {
                path: ':unitId(\\d+)',
                name: consts.routerNames.units.id,
                meta: {
                    mainRouteName: consts.routerNames.units.main,
                    parentRouteName: consts.routerNames.units.main,
                    sectionInfoByRoute: true,
                    pageClass: 'prometheus-portal-units',
                    layers: {
                        ...consts.defaultSettingsLayers,
                        units: {visible: true, showInList: true, showLayer: true},
                        geoitems: {visible: false, showInList: true, showLayer: true},
                    }
                },
                props: {
                    default: function (route) {
                        let params = replaceParams(route)
                        return {unitId: +params.unitId}
                    },
                },
                components: {
                    default: UnitInfo,
                },
                children: [
                    //info
                    {
                        path: ':template(xtrack)/info',
                        name: consts.routerNames.units.type.xtrack.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.xtrack.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.type.xtrack.info,
                            parentRouteName: consts.routerNames.units.type.xtrack.main,
                            pageClass: 'prometheus-portal__xtrack',//prometheus-portal__info
                            showSmartSearchButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                track_last_minutes: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.xtrack.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.xtrack.info,
                                    parentRouteName: consts.routerNames.units.type.xtrack.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {unitId: +params.unitId, date: params.date}
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByRouteTemplate.vue'),
                                },
                                children:[
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xtrack.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xtrack.info,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'video-event/:eventXid',
                                        name: consts.routerNames.units.type.xtrack.videoEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xtrack.info,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            pageClass: 'prometheus-portal__xtrack prometheus-portal__xtrack-video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'events',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.xtrack.videoEventUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: true, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'live-video',
                                        name: consts.routerNames.units.type.xtrack.liveVideo,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xtrack.info,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xtrack prometheus-portal__xtrack-video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                        },
                                        props: {
                                            LiveVideoComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            }
                                        },
                                        components: {
                                            LiveVideoComponent: () => import('@/components/video/control/live-video/LiveVideo.vue'),
                                        }
                                    },
                                    {
                                        path: 'video-request/:eventXid',
                                        name: consts.routerNames.units.type.xtrack.videoRequest,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xtrack.info,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            pageClass: 'prometheus-portal__xtrack prometheus-portal__xtrack-video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: true, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'requests',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.xtrack.videoRequestUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: false, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xtrack.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ]
                    }, //info xtrack
                    {
                        path: ':template(m2m)/info',
                        name: consts.routerNames.units.type.m2m.info,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.m2m.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.type.m2m.info,
                            parentRouteName: consts.routerNames.units.type.m2m.main,
                            pageClass: 'prometheus-portal__xtrack',//prometheus-portal__info
                            showSmartSearchButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                unit_zone: {visible: true, showInList: false, showLayer: true},
                                track_last_minutes: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => ({unitId: +route.params.unitId}),
                            info: (route) => ({unitId: +route.params.unitId}),
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.m2m.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.m2m.info,
                                    parentRouteName: consts.routerNames.units.type.m2m.info,
                                },
                                props: {
                                    default: (route) => ({unitId: +route.params.unitId, date: route.params.date}),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_m2m.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.m2m.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.m2m.info,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.m2m.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            }
                        ]
                    }, //info m2m
                    {
                        path: ':template(m2m_chassis)/info',
                        name: consts.routerNames.units.type.m2m_chassis.info,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.m2m_chassis.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.type.m2m_chassis.info,
                            parentRouteName: consts.routerNames.units.type.m2m_chassis.main,
                            pageClass: 'prometheus-portal__m2m_chassis',//prometheus-portal__info
                            showSmartSearchButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                unit_zone: {visible: true, showInList: false, showLayer: true},
                                track_last_minutes: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => ({unitId: +route.params.unitId}),
                            info: (route) => ({unitId: +route.params.unitId}),
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.m2m_chassis.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.m2m_chassis.info,
                                    parentRouteName: consts.routerNames.units.type.m2m_chassis.info,
                                },
                                props: {
                                    default: (route) => ({unitId: +route.params.unitId, date: route.params.date}),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_m2m_chassis.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.m2m_chassis.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.m2m_chassis.info,
                                            parentRouteName: consts.routerNames.units.type.m2m_chassis.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.m2m_chassis.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m_chassis.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            }
                        ]
                    }, //info m2m
                    {
                        path: ':template(xvision)/info',
                        name: consts.routerNames.units.type.xvision.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.xvision.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.type.xvision.info,
                            parentRouteName: consts.routerNames.units.type.xvision.main,
                            pageClass: 'prometheus-portal__xvision',//prometheus-portal__info
                            showSectionInfoByMeta: true,
                            isVideo: true,
                            showSmartSearchButton: true,
                            showTimeCapsuleButton: true,
                            showPlaybackButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                track_last_minutes: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.xvision.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.xvision.info,
                                    parentRouteName: consts.routerNames.units.type.xvision.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: +params.unitId,
                                            date: params.date,
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByRouteTemplate.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xvision.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xvision.info,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            unitTracking: false,
                                            showSmartSearchButton: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'video-event/:eventXid',
                                        name: consts.routerNames.units.type.xvision.videoEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xvision.info,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            pageClass: 'prometheus-portal__xvision prometheus-portal__xvision__video',
                                            isVideo: true,
                                            weatherInMap: false,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            showSmartSearchButton: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'events',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.xvision.videoEventUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: false, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'live-video',
                                        name: consts.routerNames.units.type.xvision.liveVideo,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xvision.info,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xvision prometheus-portal__xvision__video-live',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            showSmartSearchButton: false,
                                        },
                                        props: {
                                            LiveVideoComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            }
                                        },
                                        components: {
                                            LiveVideoComponent: () => import('@/components/video/control/live-video/LiveVideo.vue'),
                                        }
                                    },
                                    {
                                        path: 'video-request/:eventXid',
                                        name: consts.routerNames.units.type.xvision.videoRequest,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xvision.info,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            pageClass: 'prometheus-portal__xvision prometheus-portal__xvision__video',
                                            isVideo: true,
                                            showMapInfo: false,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            showSmartSearchButton: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'requests',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.xvision.videoRequestUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: false, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        //ToDO fix
                                        path: ':objectType(screenshot)/:eventXid',
                                        name: consts.routerNames?.units?.type?.xvision?.snapshots,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.xvision?.info,
                                            parentRouteName: consts.routerNames?.units?.type?.xvision?.date,
                                            pageClass: 'prometheus-portal__xvision prometheus-portal-snapshots',
                                            hideInfoUnit: true,
                                            showSmartSearchButton: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                            }
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    unitId: +params.unitId,
                                                    eventXid: params.eventXid,
                                                    date: params.date,
                                                }
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/info/UnitInfo_screenWall.vue'),
                                        },
                                    },//snapshots
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xvision.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ]
                    },//info xvision
                    {
                        path: ':template(pro_cargo_vision)/info',
                        name: consts.routerNames.units.type.pro_cargo_vision.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.pro_cargo_vision.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames?.units?.type?.pro_cargo_vision?.info,
                            parentRouteName: consts.routerNames?.units?.type?.pro_cargo_vision?.main,
                            pageClass: 'prometheus-portal__pro-cargo-vision',//prometheus-portal__info
                            isVideo: true,
                            ScreenWallComponent: 'UnitsScreenWallLast_cargo_vision',
                            showSmartSearchButton: true,
                            //hideInfoUnit: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                track_last_minutes: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.pro_cargo_vision.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.pro_cargo_vision.info,
                                    parentRouteName: consts.routerNames.units.type.pro_cargo_vision.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: +params.unitId,
                                            eventXid: params.eventXid,
                                            objectType: params.objectType,
                                            date: params.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_proCargoVision.vue'),
                                },
                                children: [
                                    {
                                        path: ':objectType/:eventXid',
                                        name: consts.routerNames?.units?.type?.pro_cargo_vision?.snapshots,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.pro_cargo_vision?.info,
                                            parentRouteName: consts.routerNames.units.type.pro_cargo_vision.date,
                                            pageClass: 'prometheus-portal__pro-cargo-vision prometheus-portal-snapshots',
                                            hideInfoUnit: true,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                            }
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    unitId: +params.unitId,
                                                    eventXid: params.eventXid,
                                                }
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/info/UnitInfo_screenWall.vue'),
                                        },
                                    },//snapshots
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.pro_cargo_vision.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.pro_cargo_vision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                    {
                                        path: 'screenshots/:eventXid',
                                        name: consts.routerNames?.units?.type?.pro_cargo_vision?.screenshotsEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.pro_cargo_vision?.info,
                                            parentRouteName: consts.routerNames.units.type.pro_cargo_vision.date,
                                            pageClass: 'prometheus-portal__pro-cargo-vision prometheus-portal__pro-cargo-vision-screenshots',//prometheus-portal__info
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                            }
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId, eventXid: params.eventXid, date: params.date}
                                            },
                                        },
                                        components: {
                                            default: () => import('@/components/units/timeline/pro_cargo_vision/time-capsule/TimeCapsule_pro_cargo_vision.vue'),
                                        },
                                        children: [
                                        ]
                                    },//time-capsule
                                ]
                            },
                        ]
                    },//info pro_cargo_vision
                    {
                        path: ':template(xbles)/info',
                        name: consts.routerNames.units.type.xbles.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.xbles.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames?.units?.type?.xbles?.info,
                            parentRouteName: consts.routerNames?.units?.type?.xbles?.main,
                            pageClass: 'prometheus-portal__xbles',//prometheus-portal__info
                            isVideo: false,
                            hideInfoUnit: false,
                            showSmartSearchButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                unit_zone: {visible: true, showInList: false, showLayer: true},
                            },
                            setRoute: {
                                ...defaultSetRoute,
                                unitInfo: (route, router, unitId) => {
                                    if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                        if (consts.app.$isDevelopment) console.warn('unitInfo', route);
                                        return false;
                                    }
                                    router.push({
                                        name:  consts.routerNames?.units?.type?.xbles?.map_info?.main,
                                        params: {
                                            ...route.params,
                                            unitId,
                                        },
                                        query: {...route.query}
                                    })
                                },
                            },
                        },
                        props: {
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params?.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.xbles.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.xbles.info,
                                    parentRouteName: consts.routerNames.units.type.xbles.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xbles.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xbles.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xbles.info,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            unitTracking: false,
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'map-info',
                                        name: consts.routerNames?.units?.type?.xbles?.map_info?.main,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.xbles?.info,
                                            parentRouteName: consts.routerNames?.units?.type?.xbles?.date,
                                            // pageClass: 'prometheus-portal__xbles prometheus-portal__xbles-id',
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    unitId: params?.unitId
                                                }
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/info/xbles/UnitInfo_xbles_map_info.prometheus.vue'),
                                        },
                                    },
                                    {
                                        path: ':tagId',
                                        name: consts.routerNames?.units?.type?.xbles?.id?.main,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.xbles?.info,
                                            parentRouteName: consts.routerNames?.units?.type?.xbles?.date,
                                            // pageClass: 'prometheus-portal__xbles prometheus-portal__xbles-id',
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xbles.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ]
                    },//info xbles
                    {
                        path: ':template(obd)/info',
                        name: consts.routerNames.units?.type?.obd?.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.obd.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units?.type?.obd?.info,
                            parentRouteName: consts.routerNames.units?.type?.obd?.main,
                            pageClass: 'unit-obd',
                            isVideo: true,
                            hideInfoUnit: false,
                            showSmartSearchButton: true,
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    eventXid: params.eventXid,
                                    objectType: params.objectType,
                                    tagId: params.tagId,
                                }
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.obd.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.obd.info,
                                    parentRouteName: consts.routerNames.units.type.obd.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_obd.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.obd.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.obd.info,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            unitTracking: false,
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'live-video',
                                        name: consts.routerNames.units.type.obd.liveVideo,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.obd.info,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'unit-obd unit-obd__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                        },
                                        props: {
                                            LiveVideoComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            }
                                        },
                                        components: {
                                            LiveVideoComponent: () => import('@/components/video/control/live-video/LiveVideo.vue')
                                        },
                                    },
                                    {
                                        path: 'video-event/:eventXid',
                                        name: consts.routerNames.units.type.obd.videoEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.obd.info,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            pageClass: 'unit-obd unit-obd__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: false, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'events',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.obd.videoEventUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: false, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'video-request/:eventXid',
                                        name: consts.routerNames.units.type.obd.videoRequest,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.obd.info,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            pageClass: 'unit-obd unit-obd__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'requests',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                            {
                                                path: 'tracking',
                                                name: consts.routerNames.units.type.obd.videoRequestUnitTracking,
                                                meta: {
                                                    unitTracking: true,
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        units: {visible: true, showInList: false, showLayer: true},
                                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.obd.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },//info obd
                    {
                        path: ':template(xcool)/info',
                        name: consts.routerNames.units.type.xcool.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.xcool.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.type.xcool.info,
                            parentRouteName: consts.routerNames.units.type.xcool.main,
                            pageClass: 'prometheus-portal__xcool',//prometheus-portal__info
                            componentBlockInfo: 'UnitInfo_content_reefer',
                            showSmartSearchButton: true,
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.xcool.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.xcool.info,
                                    parentRouteName: consts.routerNames.units.type.xcool.info,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xcool.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xcool.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'history',
                                        name: consts.routerNames.units.type.xcool.history,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-history',
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId, date: route?.params?.date}
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_history.vue'),
                                        },
                                    },//history
                                    {
                                        path: 'analytics',
                                        name: consts.routerNames.units.type.xcool.analytics,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-analytics',
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params?.unitId, date: route.params?.date}
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_analytics.vue'),
                                        },
                                    },//analytics
                                    {
                                        path: 'diagnostics',
                                        name: consts.routerNames.units.type.xcool.diagnostics,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-diagnostics',
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId, date: route.params.date}
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_diagnostics.vue'),
                                        },
                                    },//diagnostics
                                    {
                                        path: 'alarms',
                                        name: consts.routerNames.units.type.xcool.alarms.main,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-alarms',
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_alarms.vue'),
                                        },
                                        children: [
                                            {
                                                path: ':alertXid',
                                                name: consts.routerNames.units.type.xcool.alarms.xid,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.type.xcool.info,
                                                    parentRouteName: consts.routerNames.units.type.xcool.alarms.main,
                                                    pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-alarms',
                                                },
                                                props: {
                                                    default: (route) => {
                                                        let params = replaceParams(route)
                                                        return {unitId: +params.unitId, alertXid: route.params.alertXid}
                                                    }
                                                },
                                                components: {
                                                    default: () => import('@/components/units/pageInfo/UnitInfo_xcool_alarms_item.vue'),
                                                },
                                            },
                                        ]
                                    },//alarms
                                    {
                                        path: 'set-point',
                                        name: consts.routerNames.units.type.xcool.setPoint,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-set-point'
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            },
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_setPoint.vue'),
                                        },
                                    },
                                    {
                                        path: 'set-point-template',
                                        name: consts.routerNames.units.type.xcool.setPointTemplate,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-set-point-template'
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            },
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_setPoint_template.vue'),
                                        },
                                    },
                                    {
                                        path: 'start-defrost',
                                        name: consts.routerNames.units.type.xcool.startDefrost,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-start-defrost'
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            },
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_startDefrost.vue'),
                                        },
                                    },
                                    {
                                        path: 'start-pti',
                                        name: consts.routerNames.units.type.xcool.startPti,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.info,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'prometheus-portal__xcool prometheus-portal__xcool-start-pti'
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            },
                                        },
                                        components: {
                                            default: () => import('@/components/units/pageInfo/UnitInfo_xcool_startPti.vue'),
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xcool.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    wrapper: 'EditWizard',
                                                    class: 'popup-body',
                                                    unitId: params.unitId ? +params.unitId : undefined,
                                                }
                                            }
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ]
                    }, //info xcool
                    {
                        path: ':template(sensors)/info',
                        name: consts.routerNames.units?.type?.sensors?.info,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.type.sensors.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units?.type?.sensors?.info,
                            parentRouteName: consts.routerNames.units?.type?.sensors?.main,
                            pageClass: 'unit-sensors',
                            isVideo: true,
                            hideInfoUnit: false,
                            showSmartSearchButton: true,
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    date: params.date,
                                }
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.type.sensors.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.sensors.info,
                                    parentRouteName: consts.routerNames.units.type.sensors.info,
                                    setRoute: {
                                        ...defaultSetRoute,
                                        'video-request': (route, router, unitId, eventXid) => {
                                            if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                                if (consts.app.$isDevelopment) console.warn('video-request', route);
                                                return false
                                            }
                                            let template = route?.params?.template
                                            let routeParams = getUnitDefaultRouteParams(unitId, template)
                                            let query = clearQueryFilter(route.query)

                                            router.push({
                                                name: routeParams.routeName['videoRequest'],
                                                params: {
                                                    ...routeParams.params,
                                                    template,
                                                    eventXid,
                                                },
                                                query
                                            })
                                        },
                                    }
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_sensors.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.sensors.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.sensors.info,
                                            parentRouteName: consts.routerNames.units.type.sensors.date,
                                            unitTracking: false,
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'live-video',
                                        name: consts.routerNames.units.type.sensors.liveVideo,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.sensors.info,
                                            parentRouteName: consts.routerNames.units.type.sensors.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'unit-sensors unit-sensors__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                        },
                                        props: {
                                            LiveVideoComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {unitId: +params.unitId}
                                            }
                                        },
                                        components: {
                                            LiveVideoComponent: () => import('@/components/video/control/live-video/LiveVideo.vue')
                                        },
                                    },
                                    {
                                        path: 'video-event/:eventXid',
                                        name: consts.routerNames.units.type.sensors.videoEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.sensors.info,
                                            parentRouteName: consts.routerNames.units.type.sensors.date,
                                            pageClass: 'unit-sensors unit-sensors__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: false, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'events',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                        ]
                                    },
                                    {
                                        path: 'video-request/:eventXid',
                                        name: consts.routerNames.units.type.sensors.videoRequest,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.sensors.info,
                                            parentRouteName: consts.routerNames.units.type.sensors.date,
                                            pageClass: 'unit-sensors unit-sensors__video',
                                            isVideo: true,
                                            sectionInfoByRoute: false,
                                            hideInfoUnit: true,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            },
                                        },
                                        props: {
                                            VideoEventComponent: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    eventXid: params.eventXid,
                                                    objectType: 'requests',
                                                    showIcon: false,
                                                    showUnitName: false,
                                                    showDate: false,
                                                    showDuration: false,
                                                    showAddress: false,
                                                    showDownload: false
                                                }
                                            }
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                        },
                                        children: [
                                        ]
                                    },
                                ]
                            },
                        ],
                    },//info obd

                    //smartSearch
                    {
                        path: ':template/smart-search',
                        name: consts.routerNames.units.smartSearch.main,
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            blockingRoutesTransitionFromOutside: true,
                            pageClass: 'prometheus-portal__xvision prometheus-portal-smart-search',
                            unitTracking: false,
                            showSmartSearchButton: true,
                            hideInfoUnit: true,
                            viewComponent: 'UnitControl_smartSearch',
                            layers: {
                                ...consts.defaultSettingsLayers,
                            },
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.smartSearch.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.smartSearch.main,
                                    parentRouteName: consts.routerNames.units.smartSearch.main,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: route?.params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_smartSearch.vue'),
                                },
                                children: [
                                    {
                                        path: ':mode(time)/:from(\\d+)?/:to(\\d+)?',
                                        name: consts.routerNames.units.smartSearch.time.main,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.smartSearch.main,
                                            parentRouteName: consts.routerNames.units.smartSearch.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                smartSearch: {visible: true, showInList: false, showLayer: true},
                                            },
                                        },
                                        children: [
                                            {
                                                path: 'video-request/:eventXid',
                                                name: consts.routerNames.units.smartSearch.time.videoRequest,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.smartSearch.main,
                                                    parentRouteName: consts.routerNames.units.smartSearch.time.main,
                                                    pageClass: 'prometheus-portal__xvision prometheus-portal-smart-search prometheus-portal-smart-search__video',
                                                    isVideo: true,
                                                    showMapInfo: false,
                                                    sectionInfoByRoute: false,
                                                },
                                                props: {
                                                    VideoEventComponent: (route) => {
                                                        let params = replaceParams(route)
                                                        return {
                                                            eventXid: params.eventXid,
                                                            objectType: 'requests',
                                                            showIcon: false,
                                                            showUnitName: false,
                                                            showDate: false,
                                                            showDuration: false,
                                                            showAddress: false,
                                                            showDownload: false
                                                        }
                                                    }
                                                },
                                                components: {
                                                    VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                                },
                                            },
                                            {
                                                path: ':accidentId',
                                                name: consts.routerNames.units.smartSearch.time.accidentView,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.smartSearch.main,
                                                    parentRouteName: consts.routerNames.units.smartSearch.time.main,
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        path: ':mode(geozone)',
                                        name: consts.routerNames.units.smartSearch.geozone.main,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.smartSearch.main,
                                            parentRouteName: consts.routerNames.units.smartSearch.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: true, showInList: true, showLayer: true},
                                                smartSearch: {visible: true, showInList: false, showLayer: true},
                                            },
                                        },
                                        children: [
                                            {
                                                path: 'video-request/:eventXid',
                                                name: consts.routerNames.units.smartSearch.geozone.videoRequest,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.smartSearch.main,
                                                    parentRouteName: consts.routerNames.units.smartSearch.time.main,
                                                    pageClass: 'prometheus-portal__xvision prometheus-portal-smart-search prometheus-portal-smart-search__video',
                                                    isVideo: true,
                                                    showMapInfo: false,
                                                    sectionInfoByRoute: false,
                                                },
                                                props: {
                                                    VideoEventComponent: (route) => {
                                                        let params = replaceParams(route)
                                                        return {
                                                            eventXid: params.eventXid,
                                                            objectType: 'requests',
                                                            showIcon: false,
                                                            showUnitName: false,
                                                            showDate: false,
                                                            showDuration: false,
                                                            showAddress: false,
                                                            showDownload: false
                                                        }
                                                    }
                                                },
                                                components: {
                                                    VideoEventComponent: () => import('@/components/video/control/video-component/VideoComponent.vue')
                                                },
                                            },
                                            {
                                                path: ':accidentId',
                                                name: consts.routerNames.units.smartSearch.time.accidentView,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.smartSearch.main,
                                                    parentRouteName: consts.routerNames.units.smartSearch.time.main,
                                                }
                                            },
                                        ]
                                    },
                                ]
                            },

                        ]
                    },//smartSearch

                    //time-capsule(xvision)
                    {
                        path: ':template(xvision)/time-capsule',
                        name: consts.routerNames.units.timeCapsule.template.xvision.main,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.timeCapsule.template.xvision.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.timeCapsule.template.xvision.main,
                            parentRouteName: consts.routerNames.units.timeCapsule.template.xvision.main,
                            pageClass: 'prometheus-portal-time-capsule prometheus-portal-time-capsule__xvision prometheus-portal__xvision',
                            unitTracking: false,
                            //showSmartSearchButton: true,
                            hideInfoUnit: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                unit_mouse_move: {visible: true, showInList: false, showLayer: true},
                            },
                            setRoute: {
                                ...defaultSetRoute,
                                unitIdShifts: (route, router, unitId, date, timeFrom, timeTo, template) => {
                                    if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                        if (consts.app.$isDevelopment) console.warn('unitId', route);
                                        return false;
                                    }
                                    if (store.getters?.getUnitsOnMap?.length) {
                                        store.commit('setUnitsShowOnMap', {
                                            showOnMap: false,
                                            unitIds: store.getters?.getUnitsOnMap
                                        })
                                    }

                                    let routeParams = getUnitDefaultRouteParams(unitId, template)
                                    let query = clearQueryFilter(route.query)
                                    date = date || route?.params?.date || store.getters.getDateToday
                                    let routeName = timeFrom && timeTo ? route.name : (routeParams?.routeName?.date || consts?.routerNames?.units?.id)

                                    router.push({
                                        name: routeName,
                                        params: {
                                            ...routeParams?.params,
                                            date,
                                            timeFrom,
                                            timeTo,
                                        },
                                        query
                                    })
                                },
                            }
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']//, 'ext_services', 'photo'
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?',
                                name: consts.routerNames.units.timeCapsule.template.xvision.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.timeCapsule.template.xvision.main,
                                    parentRouteName: consts.routerNames.units.timeCapsule.template.xvision.main,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: +params?.unitId,
                                            date: route?.params?.date,
                                            channelId: +route?.query?.channelId,
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_timeCapsule_xvision.vue'),
                                },
                                children: [
                                    {
                                        path: ':eventXid',
                                        name: consts.routerNames.units.timeCapsule.template.xvision.video,
                                        meta:{
                                            mainRouteName: consts.routerNames.units.timeCapsule.template.xvision.main,
                                            parentRouteName: consts.routerNames.units.timeCapsule.template.xvision.date,
                                            sectionPopupByRoute: true
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {eventXid: params.eventXid, unitId: +params?.unitId}
                                            }
                                        },
                                        components: {
                                            // sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                            sectionPopupByRoute: () => import('@/components/units/screen-wall/time-capsule/TimeCapsuleModalInfo.vue')
                                        }
                                    }
                                ]
                            },
                        ]
                    },//time-capsule(xvision)

                    //playback(xvision)
                    {
                        path: ':template(xvision)/playback',
                        name: consts.routerNames.units.playback.template.xvision.main,
                        redirect: to => {
                            let params = replaceParams(to)
                            return {
                                name: consts.routerNames.units.playback.template.xvision.date,
                                params: {
                                    ...params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.playback.template.xvision.main,
                            parentRouteName: consts.routerNames.units.playback.template.xvision.main,
                            pageClass: 'prometheus-portal-playback prometheus-portal-playback__xvision prometheus-portal__xvision',
                            unitTracking: false,
                            hideInfoUnit: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                unit_mouse_move: {visible: true, showInList: false, showLayer: true},
                            },
                            setRoute: {
                                ...defaultSetRoute,
                                unitIdShifts: (route, router, unitId, date, timeFrom, timeTo, template) => {
                                    if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                        if (consts.app.$isDevelopment) console.warn('unitId', route);
                                        return false;
                                    }
                                    if (store.getters?.getUnitsOnMap?.length) {
                                        store.commit('setUnitsShowOnMap', {
                                            showOnMap: false,
                                            unitIds: store.getters?.getUnitsOnMap
                                        })
                                    }

                                    let routeParams = getUnitDefaultRouteParams(unitId, template)
                                    let query = clearQueryFilter(route.query)
                                    date = date || route?.params?.date || store.getters.getDateToday
                                    let routeName = timeFrom && timeTo ? route.name : (routeParams?.routeName?.date || consts?.routerNames?.units?.id)

                                    router.push({
                                        name: routeName,
                                        params: {
                                            ...routeParams?.params,
                                            date,
                                            timeFrom,
                                            timeTo,
                                        },
                                        query
                                    })
                                },
                            }
                        },
                        props: {
                            default: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                            info: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params.unitId,
                                    infoList: ['unit_info', 'notifications', 'sensors', 'driver']
                                }
                            },
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_info.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:timeFrom(\\d+)?/:timeTo(\\d+)?/:time(\\d+)?',
                                name: consts.routerNames.units.playback.template.xvision.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.playback.template.xvision.main,
                                    parentRouteName: consts.routerNames.units.playback.template.xvision.main,
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: +params?.unitId,
                                            date: route?.params?.date,
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_playback_xvision.vue'),
                                },
                            },
                        ]
                    },//playback(xvision)

                    //track
                    {
                        path: ':template/track/:date(\\d{4}-\\d{2}-\\d{2})?',
                        name: consts.routerNames.units.track.main,
                        meta: {
                            mainRouteName: consts.routerNames.units.track.main,
                            parentRouteName: consts.routerNames.units.track.main,
                            unitTracking: false,
                            pageClass: 'unit-track-page',
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: false, showInList: false, showLayer: true},
                                geoitems: {visible: false, showInList: false, showLayer: true},
                                tracks: {visible: true, showInList: false, showLayer: true},
                            },

                        },
                        props: {
                            // default: (route) => ({unitId: +route.params.unitId}),
                            info: (route) => {
                                let params = replaceParams(route)
                                return {unitId: +params.unitId}
                            },
                        },
                        components: {
                            default: () => import('@/views/prometheus/portal/TracksPage.vue'),
                            info: () => import('@/components/units/pageInfo/info-block/content-info/UnitInfo_content_track.vue'),
                        },
                        children: [
                            {
                                path: 'asset',
                                name: consts.routerNames.units.track.asset.main,
                                meta: {
                                    layers: {
                                        ...consts.defaultSettingsLayers,
                                        geoitems: {visible: false, showInList: true, showLayer: true},
                                        tracks: {visible: false, showInList: false, showLayer: false},
                                        track_by_points: {visible: true, showInList: false, showLayer: true},
                                    },
                                },
                                children: [
                                    {
                                        path: ':index',
                                        name: consts.routerNames.units.track.asset.index,
                                        meta:{
                                            mainRouteName: consts.routerNames.tracks.main,
                                            parentRouteName: consts.routerNames.tracks.unit.asset.main,
                                        },
                                    },
                                ]
                            },
                            {
                                path: ':type(parking|driving)/:trackXid:/:timeFrom(\\d+)/:timeTo(\\d+)/:trackColor(track-color)?/:speed(\\d+)?',
                                name: consts.routerNames.units.track.xid,
                                meta: {
                                    mainRouteName: consts.routerNames.units.track.main,
                                    parentRouteName: consts.routerNames.units.track.main,
                                    unitTracking: false,
                                },
                                children: [
                                    {
                                        path: ':trackEventType/:trackEventXid',
                                        name: consts.routerNames.units.track.event_xid,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.track.main,
                                            parentRouteName: consts.routerNames.units.track.main,
                                        },
                                        children: [
                                            {
                                                path: 'video-event-popup',
                                                name: consts.routerNames.units.track.video.event,
                                                meta:{
                                                    mainRouteName: consts.routerNames.units.track.main,
                                                    parentRouteName: consts.routerNames.units.track.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'events'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            },
                                            {
                                                path: 'video-request-popup',
                                                name: consts.routerNames.units.track.video.request,
                                                meta:{
                                                    mainRouteName: consts.routerNames.units.track.main,
                                                    parentRouteName: consts.routerNames.units.track.event_xid,
                                                    sectionPopupByRoute: true
                                                },
                                                props: {
                                                    sectionPopupByRoute: (route) => ({eventXid: route.params.trackEventXid, objectType: 'requests'})
                                                },
                                                components: {
                                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                                }
                                            }
                                        ]
                                    },
                                ]
                            },
                        ]
                    },

                    //xRoute
                    {
                        path: ':template/xRoute',
                        name: consts.routerNames.units.xroute.main,
                        meta: {
                            mainRouteName: consts.routerNames.units.xroute.main,
                            parentRouteName: consts.routerNames.units.xroute.main,
                            blockingRoutesTransitionFromOutside: true,
                            sectionInfoByRoute: true,
                            unitTracking: false,
                            pageClass: 'prometheus-portal__xtrack',
                            hideInfoUnit: false,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                xroute: {visible: true, showInList: true, showLayer: true},
                            },
                            setRoute: {
                                ...defaultSetRoute,
                                event: (route, router, unitId, eventXid) => {
                                    if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                        if (consts.app.$isDevelopment) console.warn('event', route);
                                        return false
                                    }
                                    let template = route?.params?.template
                                    let routeParams = getUnitDefaultRouteParams(unitId, template)
                                    let query = clearQueryFilter(route.query)
                                    router.push({
                                        name: consts.routerNames.units.xroute.event,
                                        params: {
                                            ...route.params,
                                            ...routeParams.params,
                                            eventXid,
                                        },
                                        query
                                    })
                                },
                            }
                        },
                        props: {
                            info: (route) => {
                                return {
                                    unitId: +route?.params?.unitId
                                }
                            },
                            default: (route) => {
                                return {
                                    unitId: +route?.params?.unitId,
                                    date: route?.params?.date
                                }
                            }
                        },
                        components: {
                            info: () => import('@/components/units/xRoute/xRouteFetches.vue'),
                            default: () => import('@/components/units/requestsComponents/requestsByDate_xroute.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.xroute.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.xroute.main,
                                    parentRouteName: consts.routerNames.units.xroute.id.calculateRouteId,
                                },
                                props: {
                                    infoView: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: route?.params?.date
                                        }
                                    },
                                },
                                components: {
                                    infoView: () => import('@/components/routeView.vue'),
                                },
                                children: [
                                    {
                                        path: ':routeId(\\d+)',
                                        name: consts.routerNames.units.xroute.id.main,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.xroute.main,
                                            parentRouteName: consts.routerNames.units.xroute.main,
                                        },
                                        props: {
                                            default: (route) => {
                                                let params = replaceParams(route)
                                                return {
                                                    unitId: +params.unitId,
                                                    routeId: +params.routeId,
                                                    calculateRouteId: +params.calculateRouteId,
                                                    waypointId: +params.waypointId,
                                                    waypointType: params.waypointType,
                                                }
                                            }
                                        },
                                        components: {
                                            default: () => import('@/components/units/xRoute/xRouteComponent.vue'),
                                        },
                                        children: [
                                            {
                                                path: ':calculateRouteId(\\d+)/:waypointType?/:waypointId(\\d+)?',
                                                name: consts.routerNames.units.xroute.id.calculateRouteId,
                                                meta: {
                                                    mainRouteName: consts.routerNames.units.xroute.main,
                                                    parentRouteName: consts.routerNames.units.xroute.id.main,
                                                },
                                                props: {
                                                    default:(route) => {
                                                        return {
                                                            unitId: +route?.params?.unitId,
                                                            routeId: +route?.params?.routeId,
                                                            calculateRouteId: +route?.params?.calculateRouteId,
                                                            waypointId: +route?.params?.waypointId,
                                                            waypointType: route?.params?.waypointType,
                                                        }
                                                    }
                                                },
                                                components: {
                                                    default: () => import('@/components/units/xRoute/xRouteWaypoints.vue'),
                                                },
                                                children: [
                                                    {
                                                        path: 'event/:eventXid',
                                                        name: consts.routerNames.units.xroute.event,
                                                        meta: {
                                                            mainRouteName: consts.routerNames.units.xroute.main,
                                                            parentRouteName: consts.routerNames.units.xroute.date,
                                                            unitTracking: false,
                                                            layers: {
                                                                ...consts.defaultSettingsLayers,
                                                                units: {visible: false, showInList: false, showLayer: false},
                                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                                notifications: {visible: true, showInList: false, showLayer: true},
                                                                xroute: {visible: true, showInList: false, showLayer: true},
                                                            }
                                                        },
                                                        props: {
                                                        },
                                                        components: {
                                                        },
                                                    },
                                                ]
                                            }
                                        ]
                                    },
                                ]
                            },
                        ]
                    },

                    //fastGeozone
                    {
                        path: ':template/fast-geozone',
                        name: consts.routerNames.units.fastGeozone.main,
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'fast-geozone-edit',
                            blockingRoutesTransitionFromOutside: true,
                            sectionInfoByRoute: true,
                            fastGeozone: true,
                            hideInfoUnit: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                geoitem_edit: {visible: true, showInList: false, showLayer: true},
                            },
                            setRoute: {
                                ...defaultSetRoute,
                                addGeozoneGroupEdit: (route, router) => {
                                    if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
                                        if(consts.app.$isDevelopment) console.warn('addGeozoneGroupEdit', route);
                                        return false
                                    }
                                    defaultSetRoute.fastGeoitemGroup(route, router)
                                },
                                returnToParent: (route, router) => {
                                    if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                        if (consts.app.$isDevelopment) console.warn(consts.routerNames.units.main + ' returnToParent', route);
                                        return false;
                                    }
                                    let unitId = route.params?.unitId
                                    let template = route.params?.template
                                    let date = route.params?.date
                                    defaultSetRoute.unitId(route, router, unitId, date, template)
                                }
                            }
                        },
                        props: {
                            sectionInfoByRoute: (route) => {
                                let params = replaceParams(route)
                                return {
                                    unitId: +params?.unitId,
                                    time: 1
                                }
                            }
                        },
                        components: {
                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                        },
                        children: [
                            {
                                path: 'group',
                                name: consts.routerNames.units.fastGeozone.group,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.fastGeozone.main,
                                    setRoute: {
                                        ...defaultSetRoute,
                                        returnToParent: (route, router) => {
                                            if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                                if (consts.app.$isDevelopment) console.warn(consts.routerNames.units.main + ' returnToParent', route);
                                                return false;
                                            }
                                            defaultSetRoute.fastGeoitem(route, router, route?.params?.unitId)
                                        }
                                    }
                                },
                                props: {
                                    geozoneEditGroup: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: +params?.unitId
                                        }
                                    }
                                },
                                components: {
                                    geozoneEditGroup: () => import('@/components/geoitems/geozones-groups/PopupGeozoneGroupEdit.vue'),
                                },
                            },
                        ]
                    },

                ],
            },
        ],
        // beforeEnter: (to, from) => {
        //     if(from.name && from.name != 'Login'){// First load not correct getUserStorageKey == 0
        //         let unitsIdPage = {name: 'Units', params: {unitId: localStorage.getItem(store.getters.getUserStorageKey+'.unit.active')}}
        //         if(to.name == 'Units' && !to?.params?.unitId) {
        //             return to?.params?.unitId ? to : unitsIdPage
        //         } else{
        //             return true
        //         }
        //     } else
        //     if(to?.params?.unitId) {// First load
        //         return {...to, params: {}}
        //     }
        // },
        // Vuex version !!!
        // beforeEnter: (to) => {
        //     // let unitId = localStorage.getItem(this.getUserStorageKey + '.unit.active')*1
        //     let unitId = to.params?.unitId
        //     if (!unitId) {
        //         unitId = localStorage.getItem(store.getters.getUserStorageKey+'.unit.active')*1
        //         to.params.unitId = unitId
        //     }
        //     //return false
        // },
    },
    {
        path: 'units/:unitId(\\d+)/:template/edit',
        name: consts.routerNames.units.edit.main,
        meta: {
            list: false,
            mainRouteName: consts.routerNames.units.main,
            parentRouteName: consts?.routerNames?.units?.id,
            pageLayout: 'unit-edit-page',
            blockingRoutesTransitionFromOutside: true,
            showMap: true,
            unitTracking: true,
            layers: {
                ...consts.defaultSettingsLayers,
                units: {visible: true, showInList: true, showLayer: true},
                unit_zone: {visible: true, showInList: false, showLayer: true},
                geoitems: {visible: false, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
            getUnitDefaultRouteParams: (unitId) => getUnitDefaultRouteParams(unitId)
        },
        props: {
            default: function (route) {
                let params = replaceParams(route)
                return {
                    unitId: +params.unitId,
                }
            },
        },
        components: {
            default: () => import('@/views/prometheus/portal/UnitEditPage.vue'),
        },
    }
];

export {routesUnits, getUnitDefaultRouteParams}